import React from 'react';
import { Row, Column } from '@upgrade/react-components';

import Fluid from '../../Fluid';
import { MainTitle } from '../styles';

import {
  WhyChooseUsSection,
  HighlightColumn,
  HighlightContainer,
  HighlightTitle,
  HighlightSubtitle
} from '../../about/styles';

const WhyChooseUs = ({ title, subtitle, backgroundColor, fontColor, highlights }) => (
  <WhyChooseUsSection data-color={backgroundColor || '#3f465e'} data-font-color={fontColor || '#ffffff'}>
    <Fluid>
      <Row xsHorizontalAlign="center">
        <Column xs={12}>
          <MainTitle as="h2">{title}</MainTitle>
          <p>{subtitle}</p>
        </Column>
      </Row>
      <Row>
        {highlights.map(highlight => (
          <HighlightColumn xs={6} sm={3}>
            <HighlightContainer>
              <HighlightTitle>{highlight.title}</HighlightTitle>
              <HighlightSubtitle>{highlight.subtitle}</HighlightSubtitle>
            </HighlightContainer>
          </HighlightColumn>
        ))}
      </Row>
    </Fluid>
  </WhyChooseUsSection>
);

export default WhyChooseUs;
